import api from '@pray/shared/utils/api';

import type { RetentionFromCohort, RetentionToActivity, RetentionData } from './types/analytics';

export type GetRetentionAnalyticsParams = {
  experimentId: string;
  instanceName?: string;
  experimentListNumber: number;
  startDate: string;
  endDate: string;
  fromCohort: RetentionFromCohort;
  toActivity: RetentionToActivity;
  maxDays?: number;
};

export type GetRetentionAnalyticsResponse = {
  data: RetentionData;
};

/**
 * Fetches retention analytics data for an experiment.
 * Returns D0-D30 retention data for specified cohort and activity.
 */
export async function getRetentionAnalytics({
  experimentId,
  instanceName,
  experimentListNumber,
  startDate,
  endDate,
  fromCohort,
  toActivity,
  maxDays = 30,
}: GetRetentionAnalyticsParams): Promise<RetentionData> {
  if (!experimentId) throw new Error('Experiment ID is required');

  const url = `/web/studio/experiments/${experimentId}/analytics/retention`;
  const params: Record<string, string | number> = {
    experiment_list_number: experimentListNumber,
    start_date: startDate,
    end_date: endDate,
    from_cohort: fromCohort,
    to_activity: toActivity,
    max_days: maxDays,
  };

  if (instanceName) {
    params.instance_name = instanceName;
  }

  const response = await api.executeGetRequest<GetRetentionAnalyticsResponse>(url, params);

  return response.data.data;
}
